import React from 'react'
import BellIcon from 'transfix-icons/build/BellIcon'
import NotificationBadge from 'transfix-ui/components/NotificationBadge'
import { Spinner } from 'transfix-ui/components/Spinner'
import { makeStyles, Box, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { shadows } from 'transfix-ui/theme/shadows'
import NotificationList from './components/NotificationList/NotificationList'
import { useMarkAsRead, useNotificationsPolling } from './hooks'

const useNotificationsContainerStyles = makeStyles(theme => ({
  root: {
    height: 48,
    marginRight: theme.spacing(2),
    lineHeight: '48px',
    margin: '0 1px',
    zIndex: theme.zIndex.drawer + 1,

    '&:hover $listContainer': {
      display: 'block',
      overflow: 'scroll',
      maxHeight: 650,
    },
  },
  link: {
    cursor: 'pointer',
    padding: '0 16px',
    color: brandColors.white,

    '&:hover': {
      color: brandColors.white,
    },
  },
  listContainer: {
    display: 'none',
    width: 450,
    height: 'auto',
    margin: 0,
    maxHeight: 0,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 48,
    transform: 'translateX(-60%)',
    border: `1px solid ${brandColors.coolGray4}`,
    boxShadow: shadows[5],
    borderRadius: '0 0 4px 4px',
  },
  emptyState: {
    backgroundColor: brandColors.coolGray1,
    padding: theme.spacing(2),
    textAlign: 'center',
    border: `1px solid ${brandColors.coolGray4}`,
    borderRadius: '5px',
  },
  loading: {
    padding: '25px',
  },
}))

/**
 * Handles fetch and mutation logic for stateless children Notification components
 */
const NotificationsContainer = () => {
  const { markAsRead } = useMarkAsRead()
  const { loading, notifications = [], unreadCount } = useNotificationsPolling()
  const classes = useNotificationsContainerStyles()

  return (
    <div className={classes.root}>
      <div className={classes.link}>
        <NotificationBadge notificationCount={unreadCount}>
          <BellIcon size='medium' color='white' />
        </NotificationBadge>
      </div>
      <div className={classes.listContainer}>
        {!loading && notifications.length > 0 && unreadCount > 0 && (
          <NotificationList notifications={notifications} onMarkAsRead={markAsRead} />
        )}
        {loading && (
          <Box className={classes.loading}>
            <Spinner />
          </Box>
        )}
        {!loading && notifications.length === 0 && unreadCount === 0 && (
          <Box p={2} bgcolor={brandColors.white}>
            <Box className={classes.emptyState}>
              <Typography color='textSecondary' variant='body2' align='center'>
                No notifications
              </Typography>
            </Box>
          </Box>
        )}
      </div>
    </div>
  )
}

export default NotificationsContainer
